// Balona tiklaninca hangi ekran acilir: ayar kapali/alwaysSkip -> sohbet.
function resolveOpeningTab({ config, hasActiveChat, unreadCount }) {
    if (!config || !config.enabled || config.alwaysSkip) return "chat";
    const homeOn = !config.tabs || config.tabs.home !== false;
    if (config.skipWhenActiveChat !== false && (hasActiveChat || unreadCount > 0)) return "messages";
    return homeOn ? "home" : "messages";
}
module.exports = { resolveOpeningTab };



// WEBPACK FOOTER //
// ./src/utils/shell/resolveOpeningTab.js